var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7465_273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.43558 1.5625C3.77674 1.5625 -1.90735e-06 5.33924 -1.90735e-06 9.99808C-1.90735e-06 14.6569 3.77674 18.4337 8.43558 18.4337C9.74586 18.4337 11.0158 18.1338 12.1668 17.5654C12.7635 17.2707 13.0084 16.548 12.7137 15.9513C12.4189 15.3545 11.6963 15.1097 11.0995 15.4044C10.2787 15.8098 9.37362 16.0235 8.43558 16.0235C5.10783 16.0235 2.41016 13.3258 2.41016 9.99808C2.41016 6.67033 5.10783 3.97267 8.43558 3.97267C11.6959 3.97267 14.3515 6.56217 14.4577 9.79669L12.7706 8.47931C12.2462 8.06956 11.4888 8.16255 11.0791 8.68701C10.6693 9.21147 10.7623 9.9688 11.2868 10.3786L15.0852 13.3462C15.2466 13.4723 15.43 13.5508 15.6186 13.5838L15.7607 13.6L15.9032 13.5993C16.2347 13.5782 16.5562 13.4209 16.7768 13.1385L19.7445 9.34007C20.1542 8.81561 20.0612 8.05829 19.5368 7.64853C19.0123 7.23878 18.255 7.33177 17.8452 7.85623L16.8297 9.15602C16.4071 4.89253 12.8102 1.5625 8.43558 1.5625Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7465_273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.5ae889d793eb2eb9f141a90f1218572f.svg";
export { ForwardRef as ReactComponent };